export var StatusAuditDocument;
(function (StatusAuditDocument) {
    StatusAuditDocument["PENDING"] = "PENDING";
    StatusAuditDocument["APPROVED"] = "APPROVED";
    StatusAuditDocument["REJECTED"] = "REJECTED";
    StatusAuditDocument["DELETED"] = "DELETED";
})(StatusAuditDocument || (StatusAuditDocument = {}));
